export default __webpack_public_path__ + "static/media/app_embed__theme_customization.9e5deecc.png";